import storage from "good-storage";
const wechatCodeKey = "_wechatCode_";
const userInfoKey = "_userInfo_";
const tokenKey = "_token_";
const isLoginKey = "_isLogin_";
const homeShop = "_homeShop_"
const redirect = "_redirect_"

export function getWXCode() {
  return storage.get(wechatCodeKey);
}
export function setWXCode(code) {
  storage.set(wechatCodeKey, code);
  return code;
}

export function getUserInfo() {
  return storage.get(userInfoKey) || {};
}
export function setUserInfo(userInfo) {
  storage.set(userInfoKey, userInfo);
  return userInfo;
}

export function getHomeShop() {
  return storage.get(homeShop);
}
export function setHomeShop(data) {
  storage.set(homeShop, data);
}

export function getToken() {
  if (
    process.env.NODE_ENV === "production" ||
    process.env.NODE_ENV === "test"
  ) {
    return storage.get(tokenKey);
  } else {
    return (
      storage.get(tokenKey) ||
      "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJvcGVuaWQiOiJqWCsrUnJMby9JWnFGRTJYRDFGUWJ4S3hEa2hBNFMyQ3d1bGFTMCtZN2ZSVzlCYXVDRDZCaTY5OVpnalViSGVNIiwiZXhwIjoxNzE4MjgzNzI1fQ.FimbVE2TDSQayyK7zyGQpgNhPEAFsoe_V793AZj_M5M"
    );
  }
}
export function setToken(token) {
  storage.set(tokenKey, token);
}
export function removeToken() {
  storage.remove(tokenKey);
}
export function removeVXCode() {
  storage.remove(wechatCodeKey);
}
export function setIsLogin(flag) {
  storage.set(isLoginKey, flag);
}
export function getIsLogin() {
  return storage.get(isLoginKey);
}
export function removeIsLogin() {
  storage.remove(isLoginKey);
}
export function setRedirect(data) {
  storage.set(redirect, data);
  return data;
}
export function getRetRedirect() {
  return storage.get(redirect);
}


// WEBPACK FOOTER //
// ./src/utils/cache.js